import {head, isNotNil} from 'ramda';

import {useThunkDispatch} from '../../../hooks/useThunkDispatch';
import {getAudit, getAuditStructure} from '../../../store/carAudit/actions';

export function useFetchAuditWithAuditStructure(inspectionId: string) {
  const dispatch = useThunkDispatch();

  const fetchAuditWithAuditStructure = () => {
    return dispatch(
      getAudit.action({
        auditId: inspectionId,
      })
    )
      .unwrap()
      .then((response) => {
        const auditStructureId = head(response)?.controlStructureId;

        if (isNotNil(auditStructureId)) {
          dispatch(getAuditStructure.action({auditStructureId}));
        }
      });
  };

  return {fetchAuditWithAuditStructure};
}
